import { useEffect, useState } from 'react';
import { getData } from '../../utils/apiCalls';

export const StatsBanner = () => {
   const [data, setData] = useState()

   // useEffect(() => {
   //    getData(`https://youngstartup.io/api/cwebsite/get_speakers_dyn`)
   //       .then(res => {
   //          setData(res)
   //       })
   // }, [])
   
   const items = [
      { title: `130+`, content: 'Featured Investors' },
      { title: `190+`, content: 'Top Innovators' },
      { title: '$280B', content: 'Under management' },
      { title: '1000+', content: 'Attendees' },
      { title: '2500', content: '1 on 1 Meetings' },
   ]


   return (
      <div className='stats-banner'>
         <h1>WHERE INNOVATION MEETS CAPITAL<sup>TM</sup></h1>
         <main>
            {items.map((item, index) => {
               return (
                  <div key={index} className='stats-item'>
                     <div className='img-txt'>
                        <h3>{item.title}</h3>
                        <h6>{item.content}</h6>
                     </div>
                     <span>/</span>
                  </div>
               )
            })}
         </main>
      </div>
   )
}
